var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { Scene } from '../../learnware/LearnwareEnums';
import { runtime } from '../../runtime/Runtime';
export class StageScene {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get stage() {
        return this.parent;
    }
    get app() {
        return this.stage.app;
    }
    get currentScene() {
        if (runtime.isServerRuntime) {
            return Scene.Loading;
        }
        if (!this.app.topic) {
            return Scene.Empty;
        }
        if (this.app.appMode.isInPreviewMode && this.app.edit.editCenter.centerEditItem.type === 'question') {
            return Scene.PreviewQuestion;
        }
        if (this.app.funnel.funnelIncoming.isFunnelReady &&
            this.app.funnel.funnelLine.funnelAnswers.length === 0 &&
            (!this.app.answer || this.app.answer.finishDate)) {
            return Scene.NoMoreQuestions;
        }
        if (this.app.answer && this.app.answer.question && this.app.answer && this.app.answer.question) {
            return Scene.ShowQuestion;
        }
        return Scene.Loading;
    }
}
__decorate([
    computed
], StageScene.prototype, "currentScene", null);
